import styled from 'styled-components';

export const PatientPortalDemoFormStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
